// extracted by mini-css-extract-plugin
export default {"tableContainer":"ClientTable_tableContainer__sogi7","icon":"ClientTable_icon__IRoN1"};